import type { HelpFile } from '../../types/help'
import { LlmPromptDetailTestIds } from '../../../testids/LlmPromptDetailTestIds'

export const llmPromptDetailHelp: HelpFile = {
  docPage: '/docs/admin/llm-prompts',
  texts: {
    [LlmPromptDetailTestIds.llmPromptDetailPage]:
      'Edit an LLM prompt template — view metadata, modify the prompt body, and test it against the live model.',
    [LlmPromptDetailTestIds.cardLlmPromptMetadata]:
      'Metadata about this prompt — key, model, owning module, and description.',
    [LlmPromptDetailTestIds.cardTitlePromptEditor]:
      'Edit the prompt body — variables in {{double-braces}} are interpolated at runtime.',
    [LlmPromptDetailTestIds.cardTitleTestPanel]:
      'Send the rendered prompt to the LLM with sample input to validate the result.',
    [LlmPromptDetailTestIds.llmPromptEditor]:
      'Source editor for the prompt body — use Render Preview to see how variables expand.',
    [LlmPromptDetailTestIds.llmPromptTextarea]: null,
    [LlmPromptDetailTestIds.llmPromptVariables]:
      'Variable names referenced by the prompt — provide values in the test panel to render a preview.',
    [LlmPromptDetailTestIds.renderedPromptPreview]:
      'Preview of the prompt after variables are substituted — this is what is sent to the model.',
    [LlmPromptDetailTestIds.llmTestResponse]:
      'Response returned by the LLM for the most recent test send.',
    [LlmPromptDetailTestIds.inputTestRequest]:
      'Sample request payload used to render the prompt and call the LLM.',
    [LlmPromptDetailTestIds.btnSavePrompt]: null,
    [LlmPromptDetailTestIds.btnCancelPrompt]: null,
    [LlmPromptDetailTestIds.btnRenderPreview]:
      'Render the prompt with the supplied test variables to inspect the final text.',
    [LlmPromptDetailTestIds.btnRestoreDefault]:
      'Restore the prompt body to the shipped default — local edits will be lost.',
    [LlmPromptDetailTestIds.btnSendToLlm]: null,
    [LlmPromptDetailTestIds.btnToggleTestPanel]: null,
    [LlmPromptDetailTestIds.dialogRestoreDefault]:
      'Confirm restoring the prompt body to the shipped default — local edits will be lost.',
  },
}
